// extracted by mini-css-extract-plugin
export default {"form":"Form_form__gjyi8","divv":"Form_divv__kt5oS"};